import React from "react";
import PropTypes from "prop-types";
import ServiceCard from "../components/service-card";
import styled from "styled-components";

const ServiceWrapper = styled.div`
  justify-content: center;
  flex-wrap: wrap;
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 2rem;
`;

const LinksIcons = ({ links }) => {
  return (
    <ServiceWrapper itemScope itemType="http://schema.org/Service">
      {links?.map((link, i) => (
        <ServiceCard
          key={i}
          title={link.link?.title}
          link={link.link?.uri}
          content={link.description}
          imgUrl={link.img?.sourceUrl}
        />
      ))}
    </ServiceWrapper>
  );
};

LinksIcons.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      img: PropTypes.shape({
        sourceUrl: PropTypes.string,
      }),
      link: PropTypes.shape({
        uri: PropTypes.string,
        title: PropTypes.string,
      }),
      description: PropTypes.string,
    })
  ),
};

LinksIcons.defaultProps = {
  links: undefined,
};

export default LinksIcons;
